import {
  hideInstallHistoryModal,
  showInstallHistoryModal,
} from "@actions/modals";
import DataGrid from "@shared/DataGrid";
import React from "react";
import { connect } from "react-redux";
import { Button, Modal } from "semantic-ui-react";

class InstallHistoryModal extends React.Component {
  render() {
    const { headerDef, data, rowDef } = this.props.modal.grid;
    return (
      <Modal
        open={this.props.modal.open}
        onClose={this.props.hideInstallHistoryModal}
        size="large"
        closeIcon
      >
        <Modal.Header>Install History</Modal.Header>
        <Modal.Content>
          <DataGrid headings={headerDef} data={data} rowDef={rowDef} />
        </Modal.Content>
        <Modal.Actions>
          <Button positive onClick={this.props.hideInstallHistoryModal}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.installHistoryModal,
  };
};

export default connect(mapStateToProps, {
  showInstallHistoryModal,
  hideInstallHistoryModal,
})(InstallHistoryModal);
